module.exports = __webpack_public_path__ + "img/Group 70.1c8e2ecd.svg";